export default __webpack_public_path__ + "static/media/section3-img3.40678836.png";